module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "popcontent"
  }, [_c('div', {
    staticClass: "header_buts"
  }, [_c('div', {
    staticClass: "header_but"
  }, [_vm._v("俱乐部申报")]), _vm._v(" "), _c('div', {
    staticClass: "header_but"
  }, [_vm._v("俱乐部查询")])]), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_vm._v("相关资讯")]), _vm._v(" "), _c('div', {
    staticClass: "header_subtitle"
  }, [_vm._v("啦啦操星级俱乐部管理办法（试行）")]), _vm._v(" "), _c('div', {
    staticClass: "header_subtitle"
  }, [_vm._v("啦啦操星级俱乐部管理办法（试行）")]), _vm._v(" "), _c('div', {
    staticClass: "header_subtitle"
  }, [_vm._v("啦啦操星级俱乐部管理办法（试行）")]), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_vm._v("相关商品")]), _vm._v(" "), _c('div', {
    staticClass: "goods_item"
  }, [_c('img', {
    staticClass: "goods_item_pic",
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods_item_content"
  }, [_c('div', {
    staticClass: "goods_item_content_desc"
  }, [_vm._v("\n          训练纯棉T恤（CCA彩钻儿童（CCA彩钻儿童\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "goods_item_content_price"
  }, [_vm._v("12.00")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585df3d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/PopContent.vue
// module id = 1495
// module chunks = 0